const IBGE_MUNICIPALITIES_URL =
  "https://servicodados.ibge.gov.br/api/v1/localidades/municipios?orderBy=nome";

let cachedMunicipalities = null;
let pendingRequest = null;

const getUf = (municipality) =>
  municipality?.["regiao-imediata"]?.["regiao-intermediaria"]?.UF?.sigla ||
  municipality?.microrregiao?.mesorregiao?.UF?.sigla ||
  "";

export const loadBrazilianMunicipalities = async () => {
  if (cachedMunicipalities) return cachedMunicipalities;
  if (pendingRequest) return pendingRequest;

  pendingRequest = fetch(IBGE_MUNICIPALITIES_URL)
    .then((response) => {
      if (!response.ok) throw new Error("Falha ao consultar municípios do IBGE");
      return response.json();
    })
    .then((rows) => {
      if (!Array.isArray(rows)) throw new Error("Resposta inválida do IBGE");
      cachedMunicipalities = rows
        .map((row) => ({ id: row.id, cidade: row.nome, uf: getUf(row) }))
        .filter((row) => row.id && row.cidade && row.uf);
      return cachedMunicipalities;
    })
    .finally(() => {
      pendingRequest = null;
    });

  return pendingRequest;
};

export const clearMunicipalitiesCacheForTests = () => {
  cachedMunicipalities = null;
  pendingRequest = null;
};
